export default {
  getMatch(url) {
    let match = url.substring(url.lastIndexOf('/') + 1).split('?')[0]
    return match || 'home'
  }
}